import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  showModal as showModalAction,
  hideModal as hideModalAction,
  addToBasket as addToBasketAction,
  setProductQuantity as setProductQuantityAction,
} from '../../../molecules/basket/modules';

const ProductSelectionContainer = ({
  childComponent: ChildComponent,
  ...props
}) => <ChildComponent {...props} />;

const mapStateToProps = (state) => ({
  productQuantity: R.path(['basket', 'quantity'], state),
  currentBreakpoint: R.path(['breakpoints', 'current'], state),
});

const mapDispatchToProps = (dispatch) => ({
  showModal: () => dispatch(showModalAction()),
  hideModal: () => dispatch(hideModalAction()),
  addToBasket: (item) => dispatch(addToBasketAction({ item })),
  setProductQuantity: (quantity) =>
    dispatch(setProductQuantityAction({ quantity })),
});

ProductSelectionContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductSelectionContainer);
